module.exports = "pegasus_template/assets/grayrect-twitter.png";